import { render, staticRenderFns } from "./VuesticRadioButton.vue?vue&type=template&id=8105836e"
import script from "./VuesticRadioButton.vue?vue&type=script&lang=js"
export * from "./VuesticRadioButton.vue?vue&type=script&lang=js"
import style0 from "./VuesticRadioButton.vue?vue&type=style&index=0&id=8105836e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8105836e')) {
      api.createRecord('8105836e', component.options)
    } else {
      api.reload('8105836e', component.options)
    }
    module.hot.accept("./VuesticRadioButton.vue?vue&type=template&id=8105836e", function () {
      api.rerender('8105836e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-radio-button/VuesticRadioButton.vue"
export default component.exports